import { useQuery } from '@tanstack/react-query';
import {
	getHouseSharingHousesHouseIdSharingGetOptions,
	getHouseSharingHousesHouseIdSharingGetQueryKey,
} from '@/client/@tanstack/react-query.gen';

/**
 * Fetches the list of users a house is shared with using the auto-generated client.
 *
 * `enabled` lets a surface that only borrows the list skip it for a reader the endpoint would refuse
 * — it is gated on HOUSE_ACCESS_MANAGEMENT_MANAGE, so asking without it is a 403 on every page load.
 */
export const useSharingList = (houseId: number, enabled = true) => {
	const options = { path: { house_id: houseId } };
	return useQuery({
		...getHouseSharingHousesHouseIdSharingGetOptions(options),
		enabled: enabled && !!houseId,
	});
};

/** Re-export the query key factory for cache invalidation */
export const sharingQueryKey = (houseId: number) =>
	getHouseSharingHousesHouseIdSharingGetQueryKey({ path: { house_id: houseId } });
